// extracted by mini-css-extract-plugin
module.exports = {"block":"_2aijm","container":"_1arb3"};